import 'isomorphic-fetch';



// WEBPACK FOOTER //
// ./app/polyfills.js